//namespace Pacem {
export const Defaults = {
    USE_SHADOW_ROOT: /*'attachShadow' in Element.prototype &&*/ false /* <- wait until html-imports */
};
//}
